<template>
    <div class="cl-inner">
      <a-tabs :default-active-key="transmitId" @change="callback">
        <a-tab-pane  :tab="item.tagName" v-for="(item) in tabs" :key="item.id"></a-tab-pane>
      </a-tabs>
      <!-- 搜索 -->
      <div class="search-inner">
        <a-form layout="inline">
          <a-form-item class="name" label="标题">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="title"
              allow-clear
              style="width:303px"
            ></a-input>
          </a-form-item>
  
          <!-- <a-form-item
            label="新闻类型"
            class="form-oper"
            :labelCol="{ lg: { span: 7 } }"
            :wrapperCol="{ lg: { span: 13 } }"
          >
            <a-select
              class="form-cell"
              placeholder="请选择"
              v-model="queryParam.type"
            >
              <a-select-option
                v-for="(item, index) in portalTypeList"
                :value="item.id"
                :key="index"
                >{{ item.name }}</a-select-option
              >
            </a-select>
          </a-form-item> -->
  
          <a-form-item class="search-oper">
            <a-button type="primary" @click="searchportal()">查询</a-button>
            <!-- <a-button type="primary" @click="() => (queryParam = {})"
              >重置</a-button
            > -->
          </a-form-item>
          <a-form-item style="float:right">
            <a-button type="primary" icon="plus" @click="update('list/manage',{})"
              >新建</a-button
            >
          </a-form-item>
        </a-form>
      </div>
  
      <!-- 操作 -->
      <!-- 新闻动态的列表 -->
      <!-- <div v-if="type == 1 || type == 2">
        <a-table
          :columns="columns2"
          :dataSource="portalList"
          class="c-table"
          :pagination="pagination"
          :loading="loading"
          @change="tableChange"
        >
          <span slot="coverUrl" slot-scope="text">
            <img class="table-img" :src="text" />
          </span>
          <div slot="enable" slot-scope="status">
            <p class="status status_success" v-if="status == 1">有效</p>
            <p class="status" v-else-if="status == 0">无效</p>
            <p v-else>无</p>
          </div>
          <span slot="action" slot-scope="text, record">
            <a @click="enable(record)" class="primary" v-if="record.enable == 1"
              >下架</a
            >
            <a
              @click="enable(record)"
              class="primary"
              v-else-if="record.enable == 0"
              >上架</a
            >
            <a-divider type="vertical" />
            <a class="primary" @click="update('list/manage', record)">编辑</a>
            <a-divider type="vertical" />
            <a class="primary" @click="deleteNews(record)">删除</a>
          </span>
        </a-table>
      </div>
      <div v-else-if="type == 3">
        <a-table
          :columns="columns3"
          :dataSource="portalList"
          class="c-table"
          :pagination="pagination"
          :loading="loading"
          @change="tableChange"
        >
          <span slot="coverUrl" slot-scope="text">
            <img class="table-img" :src="text" />
          </span>
          <div slot="enable" slot-scope="status">
            <p class="status status_success" v-if="status == 1">有效</p>
            <p class="status" v-else-if="status == 0">无效</p>
            <p v-else>无</p>
          </div>
          <span slot="action" slot-scope="text, record">
            <a @click="enable(record)" class="primary" v-if="record.enable == 1"
              >下架</a
            >
            <a
              @click="enable(record)"
              class="primary"
              v-else-if="record.enable == 0"
              >上架</a
            >
            <a-divider type="vertical" />
            <a class="primary" @click="update('list/manage', record)">编辑</a>
            <a-divider type="vertical" />
            <a class="primary" @click="deleteNews(record)">删除</a>
          </span>
        </a-table>
      </div> -->
      <div>
        <!-- 表格数据 -->
        <a-table
          :columns="columns"
          :dataSource="portalList"
          class="c-table"
          :pagination="pagination"
          :loading="loading"
          @change="tableChange"
        >
          <span slot="coverUrl" slot-scope="text">
            <img class="table-img" :src="text" />
          </span>
          <div slot="enabled" slot-scope="status">
            <p class="status status_success" v-if="status == 1">有效</p>
            <p class="status" v-else-if="status == 0">无效</p>
            <p v-else>无</p>
          </div>
          <!-- <div slot="typeTagId" slot-scope="text">
            <p>{{text == 1?'放假':text == 2?'调课':text ==3?'报名':text ==4?'活动':''}}</p>
          </div> -->
          <span slot="action" slot-scope="text, record">
            <a @click="enable(record)" class="primary" v-if="record.enabled == 1"
              >下架</a
            >
            <a
              @click="enable(record)"
              class="primary"
              v-else-if="record.enabled == 0"
              >上架</a
            >
            <a-divider type="vertical" />
            <a class="primary" @click="update('list/manage',record)">编辑</a>
            <!-- <a  class="primary" @click="$refs.portalForm.init('update', record)">编辑</a> -->
            <a-divider type="vertical" />
            <a class="primary" @click="deleteNews(record)">删除</a>
          </span>
        </a-table>
      </div>
      <portal-form-modal
        ref="portalForm"
        @refreshNews="refreshNews"
      ></portal-form-modal>
    </div>
  </template>
  
  <script>
  import news from '../../api/news'
  import moment from 'moment'
  import PortalFormModal from './PortalFormModal'
  import { log } from 'util'
  // 全部 &站点公告
  const columns = [
    {
      title: '标题',
      dataIndex: 'title',
      width: '12%',
    },
    {
      title: '类型',
      dataIndex: 'typeTagName',
      scopedSlots: { customRender: 'typeTagName' },
      width: '8.63%',
    },
    {
      title: '有效时间',
      dataIndex: 'effectiveTime',
      key: 'effectiveTime',
      width: '25%',
    },
    {
      title: '状态',
      dataIndex: 'enabled',
      scopedSlots: { customRender: 'enabled' },
      width: '6.34%',
    },
    {
      title: '上传人',
      dataIndex: 'nickName',
      key: 'nickName',
      width: '8%',
    },
    {
      title: '修改时间',
      dataIndex: 'gmtModified',
      key: 'gmtModified',
      width: '15.16%',
    },
    {
      title: '操作',
      dataIndex: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ]
  // 新闻动态
  const columns2 = [
    {
      title: '标题',
      dataIndex: 'title',
      width: '20.22%',
    },
    {
      title: '上传人',
      dataIndex: 'creator',
      key: 'creator',
      width: '14.61%',
    },
    {
      title: '状态',
      dataIndex: 'enable',
      scopedSlots: { customRender: 'enable' },
      width: '8.45%',
    },
    {
      title: '修改时间',
      dataIndex: 'gmtModified',
      key: 'gmtModified',
      width: '16.45%',
    },
    {
      title: '操作',
      dataIndex: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ]
  // 家长端
  const columns3 = [
    {
      title: '标题',
      dataIndex: 'title',
      width: '15.16%',
    },
    {
      title: '有效时间',
      dataIndex: 'effectiveTime',
      key: 'effectiveTime',
      width: '19.39%',
    },
    {
      title: '状态',
      dataIndex: 'enable',
      scopedSlots: { customRender: 'enable' },
      width: '7.07%',
    },
    {
      title: '上传人',
      dataIndex: 'creator',
      key: 'creator',
      width: '6.8%',
    },
    {
      title: '修改时间',
      dataIndex: 'gmtModified',
      key: 'gmtModified',
      width: '17%',
    },
    {
      title: '操作',
      dataIndex: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ]
  
  export default {
    name: 'list',
    data() {
      return {
        title: '',
        type: '',
        typeTagId:'',
        tabs: [{id:'',tagName:'全部'}],
        tabsTwo:[],
        portalList: [], //资讯数据
        columns: JSON.parse(JSON.stringify(columns)), //列标识数据
        columns2: JSON.parse(JSON.stringify(columns2)), //列标识数据
        columns3: JSON.parse(JSON.stringify(columns3)), //列标识数据
        queryParam: {}, //查询参数
        pagination: {
          pageSize: 10,
          total: 0,
          showTotal: (total) => `总共 ${total} 条`, // 显示总数
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
          current: 1,
          currentPage: 1,
        }, //分页数据对象
        loading: true,
        transmitId:'',
      }
    },
    components: {
      PortalFormModal,
    },
    methods: {
      update(name, data) {
        data.tabsTwo = JSON.stringify(this.tabsTwo)
        data.tabsId = this.typeTagId
        data.pagination = JSON.stringify(this.pagination)
        data.titleTwo = this.title
        console.log(data,'datadatadata')
        this.$router.push({ name: name, query: data }) //->/user
      },
      moment,
      callback(key) {
        this.title = ''
        this.typeTagId = key
        console.log(this.typeTagId,key,'typetypetype')
        if (key == 0) {
          this.queryParam = {}
          this.queryParam.typeTagId = ''
        } else {
          this.queryParam = {}
          this.queryParam.typeTagId = key
        }
        this.getportalList(this.queryParam)
      },
      //刷新新闻
      refreshNews(e) {
        console.log(e,'eeeeee是啥内容')
        if(e){
          this.callback(e)
        }else{
          this.getportalList()
        }
      },
  
      //table发生该表，分页，排序
      tableChange(pagination, filters, sorter) {
        console.log(pagination,'哈哈哈哈')
        let obj = this.queryParam
        obj.currentPage = pagination.current
        obj.pageSize = pagination.pageSize
        // 切换分页放入url
        window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
          obj
        )}`
        //存在排序的时候
        if (sorter && sorter.columnKey) {
          obj.sorter = `${sorter.columnKey}-${
            sorter.portal == 'ascend' ? 'asc' : 'desc'
          }`
        }
        this.getportalList(obj)
      },
  
      //查询资讯
      searchportal() {
        this.queryParam.currentPage = 1
        this.queryParam.pageSize = 10
        this.queryParam.title = this.title
        // this.queryParam.title = this.title.replace(/\=/g, "%3D")
        //   .replace(/\+/g, "%2B")
        //   .replace(/[\s]/g, "%2F")
        //   .replace(/\?/g, "%3F")
        //   .replace(/\#/g, "%23")
        //   .replace(/\&/g, "%26")
        // console.log('111',this.queryParam.title);
        // 查询条件放到url
        window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
          this.queryParam
        )}`
        this.getportalList(this.queryParam)
      },
  
      //资讯列表
      getportalList(params) {
        console.log(params,'资讯列表里面的值')
  
        this.loading = true
        news.listNews(params).then((res) => {
          console.log('当前的资讯列表是', res.data.records)
  
          this.portalList = res.data.records
          this.loading = false
          console.log(this.tabs.length,'123486')
          if(this.tabs.length === 1){
            this.tabs.push(...res.tagList)
          }
          if(this.tabsTwo.length === 0){
            this.tabsTwo = res.tagList
            console.log(this.tabsTwo,'333364848418')
          }
          //分页信息
        //   pagination: {
        //   pageSize: 10,
        //   total: 0,
        //   showTotal: (total) => `总共 ${total} 条`, // 显示总数
        //   showSizeChanger: true,
        //   pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        //   current: 1,
        //   currentPage: 1,
        // }, //分页数据对象
          this.pagination.total = res.data.total
          this.pagination.pageSize = res.data.size
          this.pagination.current = res.data.current
          // this.pagination.currentPage = res.data.pages
        })
      },
  
      //删除新闻
      deleteNews(value, index) {
        let self = this
        this.$confirm({
          title: '确定要删除吗?',
          okText: '确定',
          cancelText: '取消',
          content: '删除后，无法撤销',
          onOk() {
            news.deleteNews(value.id).then((res) => {
              self.$message.success('删除成功')
              //前端模拟删除
              self.deleteSchoolData(self.portalList, value.id)
              self.getportalList(self.queryParam)
            })
          },
        })
      },
      //上下架
      enable(value, index) {
        console.log(value,'22222222222222222222222222')
        let self = this
        let en = ''
        if (value.enabled == 0) {
          en = 1
        } else {
          en = 0
        }
        news.enable(value.id,{ enabled: en }).then((res) => {
          self.$message.success('操作成功')
          //前端模拟删除
          self.getportalList(self.queryParam)
          // self.deleteSchoolData(self.portalList, value.id);
        })
      },
  
      //删除数据
      deleteSchoolData(data, id) {
        for (let i in data) {
          if (data[i].id == id) {
            data.splice(i, 1)
            break
          }
        }
      },
    },
  
    created(e) {
      // 判断url是否有查询参数
      if(this.$route.params.tabsId){
        // this.callback(this.$route.params.tabsId)
        this.transmitId = this.$route.params.tabsId
        console.log(this.$route.params,'paramsparamsparams')
        this.pagination = this.$route.params.pagination
        this.queryParam.currentPage = this.$route.params.pagination.current
        this.queryParam.pageSize = this.$route.params.pagination.pageSize
        this.queryParam.typeTagId = this.$route.params.tabsId
        this.queryParam.title = this.$route.params.title
        this.title = this.$route.params.title
        this.typeTagId = this.$route.params.tabsId
        this.getportalList(this.queryParam)
      }else{
        if (this.$route.query.params) {
        this.queryParam = JSON.parse(this.$route.query.params)
      } else {
        this.queryParam = {}
      }
      this.getportalList(this.queryParam)
      }
    },
  }
  </script>
  <style lang="less" scoped>
  // @import 'src/config/var';
  .cl-inner {
    width: calc(100% - 40px);
    padding: 20px;
    background: white;
    margin: 20px auto;
  }
  .search-oper {
    button {
      margin: 0px 5px;
    }
  }
  .list-oper {
    margin: 20px 0px 30px;
  }
  .person-scope {
    width: 100px;
    text-align: center;
  }
  .max-person {
    bportal-left: none;
  }
  .person-gap {
    width: 30px;
    bportal-left: 0;
    pointer-events: none;
    background: #fff;
  }
  .search-inner {
    margin-bottom: 20px;
  }
  .form-oper {
    width: 240px;
  }
  .person-oper {
    margin: 20px 0px 30px;
  }
  .table-img {
    width: 160px;
    height: 90px;
    border-radius: 4px;
  }

  .status {
    position: relative;
    padding-left: 15px;
  }
  .status::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 10px;
    background: #c0c4cf;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -3px;
  }
.status_success::after {
  background: #1890ff;
}
  </style>
  